import React from "react";
import ReportHeader from "./ReportHeader";
import LiveLog from "../adminPanel/LiveLog/LiveLog";

// Live Log as a tab inside the Report page (after the Debit/Debt report tab).
const LiveLogReport = () => {
  return (
    <div>
      <ReportHeader />
      <LiveLog />
    </div>
  );
};

export default LiveLogReport;
